import { offset, shift, flip } from '@floating-ui/react';
import {
    PRODUCT_TAGGING_MODAL_OFFSET_FROM_BOX,
    PRODUCT_TAGGING_MODAL_OFFSET_FROM_TAG,
    TAG_SIZE_NON_ADMIN_EXPANDED,
} from '../constant';

export type Placement = 'left-start' | 'right-start';

export const getConfigPopper = (
    ref: Element,
    placement: Placement = 'left-start',
) => {
    return {
        placement,
        strategy: 'absolute' as const,
        middleware: [
            // react-popper `offset` was [skidding, distance] == [crossAxis, mainAxis].
            offset({
                mainAxis: PRODUCT_TAGGING_MODAL_OFFSET_FROM_TAG,
                crossAxis: (TAG_SIZE_NON_ADMIN_EXPANDED / 2) * -1,
            }),
            // react-popper enabled `flip` by default; keep it on for parity.
            flip({
                boundary: ref,
                padding: PRODUCT_TAGGING_MODAL_OFFSET_FROM_BOX,
            }),
            // Maps react-popper `preventOverflow` (boundary + rootBoundary were the same box element).
            shift({
                boundary: ref,
                padding: PRODUCT_TAGGING_MODAL_OFFSET_FROM_BOX,
            }),
        ],
    };
};
